import React, { Component } from 'react';
import {Tabs, Tab  } from 'react-bootstrap';

import {connect} from 'react-redux';
import PartnerProductsPage from 'partners/products/PartnerProductsPage';
import PartnerTransactionsPage from 'partners/transactions/PartnerTransactionsPage';



  class PartnerPanel extends Component {

    constructor(props, context) {

        super(props, context);
        console.log('in partner panel' , this.props );
        var defaultTab ='/products'
        if (this.props.location.pathname.includes('/partner/transactions')) {
            defaultTab =   '/transactions'
        }
        this.state = {
            defaultTab : defaultTab
        };
    };
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
         };
    }

        handleSelect(key) {
        var self =this, url = '/partner'+ key
      //var SellerGroupID = _.get(this.props.userReducer.user,'CustomData.SellerGroupID','')

      if( !_.isUndefined(this.props.location.query.SellerGroupID)  && _.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), [ 'Administrator'])) > 0){
          url += '?SellerGroupID='+ this.props.location.query.SellerGroupID
      }
      self.context.router.push(url);
  };
    render() {
     var self = this;

console.log('this.state.defaultTab', this.state.defaultTab  );

        return (
            <div>
                <Tabs defaultActiveKey={this.state.defaultTab} onSelect={this.handleSelect.bind(this)} id="admin-tabs">
                     {_.size(_.intersection(this.props.userReducer.user.Roles, [ 'Administrator', 'Partner'])) > 0 &&
                    <Tab eventKey={'/products'} unmountOnExit={true} title="Products">
                        <PartnerProductsPage location={this.props.location}></PartnerProductsPage>
                    </Tab>
                    }
                    {_.size(_.intersection(this.props.userReducer.user.Roles, [ 'Administrator', 'Partner'])) > 0 &&
                    <Tab eventKey={'/transactions'} unmountOnExit={true} title="Transactions">
                        <PartnerTransactionsPage location={this.props.location}></PartnerTransactionsPage>
                    </Tab>
                    }
                </Tabs>

            </div >
        );

    }
}
function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
     };
}

export default connect(mapStateToProps, {})(PartnerPanel);